import { Result, Button } from 'antd';
import { useBatchId } from '../hooks/useBatchId';
import { ROOT } from '../shared/Routes';

export const NoAccess = () => {
	const { navigateToRoute } = useBatchId();

	const handleGoHome = () => {
		navigateToRoute(ROOT);
	};

	return (
		<div className="flex items-center justify-center h-full min-h-[400px]">
			<Result
				status="403"
				title="No Access"
				subTitle="Sorry, you do not have permission to view this page."
				extra={
					<Button type="primary" onClick={handleGoHome}>
						Go to Home
					</Button>
				}
			/>
		</div>
	);
};
